import { Directive } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AvoidCopyAndPasteActions } from '@shared/directives/avoid-copy-paste/avoid-copy-paste';
import { BaseInput } from './base-input';

export const getAvoidActionsForDisabledControls = (formControl: UntypedFormControl) => {
  return formControl.disabled ? [AvoidCopyAndPasteActions.paste, AvoidCopyAndPasteActions.cut] : [];
};

/**
 * Class used to add properties and methods that are shared for text inputs
 */
@Directive()
export class TextInput extends BaseInput {
  public avoidCopyandPasteActions = [];

  /**
   * fc control is created in initFormControl method which is invoked
   * in super class InputBase by calling initFormControl
   */
  ngOnInit(): void {
    super.ngOnInit();
    this.avoidCopyandPasteActions = getAvoidActionsForDisabledControls(this.fc);
  }
}
